import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { CssBaseline } from '@mui/material'
import { connect } from 'react-redux'
import ThemeProvider from './components/theme/ThemeProvider'
import IntlProvider from './components/theme/IntlProvider'
import AxiosInterceptors from './axios_interceptors'
import Layouts from './components/layouts'
import withClearCache from './ClearCache'
import RTL from './components/theme/Rtl'
import config from './util/config'

const ClearCacheComponent = withClearCache(PidoOperatorWebApp)

function App(props) {
  return <ClearCacheComponent {...props} />
}

function PidoOperatorWebApp(props) {

  return (
    <div dir="rtl">
      <AxiosInterceptors />
      <IntlProvider>
        <ThemeProvider>
          <RTL>
            <CssBaseline />
            <BrowserRouter basename={config.basename}>
              <Layouts />
            </BrowserRouter>
          </RTL>
        </ThemeProvider>
      </IntlProvider>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)